import React from "react";

const NotFound = () => {
  return (
    <div className="py-5">
      <h1>Not Found</h1>
    </div>
  );
};

export default NotFound;
